import styled from "styled-components";
import { glassMixin } from "../../../styles";

interface ScrollableListProps {
    scrollable: boolean;
}

export const FullHeightWrapper = styled.div`
    margin: 10px 0px 70px 0px;
`;

export const GridWrapper = styled.div`
    display: grid;
    grid-template-columns: 5fr 1fr;
    gap: 2px;
    height: 720px;
    padding-bottom: 25px;
`;

export const LeftContainer = styled.div``;

export const RightContainer = styled.div`
    height: 720px;
    position: relative;
    overflow: visible;
`;

export const ScrollableList = styled.div.withConfig({
    shouldForwardProp: (prop) => !["scrollable"].includes(prop),
})<ScrollableListProps>`
    height: ${({ scrollable }) => (scrollable ? "720px" : "auto")};
    overflow-y: ${({ scrollable }) => (scrollable ? "scroll" : "unset")};
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
    padding: 5px 10px 0px 10px;
    border-radius: 24px;

    &::-webkit-scrollbar {
        display: none; /* Chrome, Safari */
    }

    display: flex;
    flex-direction: column;

`;

export const ScrollButtonWrapper = styled.div`
    position: absolute;
    bottom: -24px;
    width: 100%;
    text-align: center;
    z-index: 15;
    display: flex;
    justify-content: center;
    gap: 10px;
`;

export const ScrollButton = styled.button`
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;

    ${glassMixin}
    background-color:rgb(184, 180, 180, 0.5);

    &:hover {
        transform: scale(1.1);
        transition: transform 0.2s ease-in-out;
    }
`;
